export default defineNuxtRouteMiddleware((to) => {
  const path = to.path

  // '/address/...' 형식의 URL 처리
  if (path.startsWith('/address/')) {
    const address = path.replace('/address/', '')
    return navigateTo(routes.getAccountDetailPageWithTab(address))
  }
  
  // '/block/...' 형식의 URL 처리  
  if (path.startsWith('/block/')) {
    const blockNumber = path.replace('/block/', '')
    return navigateTo(routes.getBlockDetailPageWithTab(blockNumber))
  }
  
  // '/tx/...' 형식의 URL 처리
  if (path.startsWith('/tx/')) {
    const txnHash = path.replace('/tx/', '')
    return navigateTo(routes.getTransactionDetailPageWithTab(txnHash))
  }
})